import { Button } from '@calendly/ui/components/button';
import { Sheet } from '@calendly/ui/components/sheet';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "ca59bgv";
export const Container = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(containerCss, props.className)} />);
const descriptionCss = "d7n6hod";
export const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const logoContainerCss = "lgbbvko";
export const LogoContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(logoContainerCss, props.className)} />;
});
const connectLogoCss = "c169iy1d";
export const ConnectLogo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(connectLogoCss, props.className)} />;
});
const plusIconCss = "p1lxbsqi";
export const PlusIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(plusIconCss, props.className)} />;
});
const connectButtonCss = "c17sw4q8";
export const ConnectButton = forwardRef((props, ref) => {
  const responsive = false;
  return <Button ref={ref} {...props} responsive={responsive} className={classNames(connectButtonCss, props.className)} />;
});

require("./elements.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./elements.js");